import React, { useState, useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const [isDisplay, setDisplay] = useState(true);
  const location = useLocation();


  useEffect(() => {
    // 'privacy-policy', 'sign-up', 'app-setup', 'onboarding',
    //   'onboarding-instaapp', 'onboarding-help', 'success', 'try-now'
    const page = window.location.pathname.split("/")[1];
    const isHiddenMenusPage = ['register','onboarding','privacy-policy'].includes(page);
    if (isHiddenMenusPage) {
      setDisplay(false)
    }else{
      setDisplay(true)
    }
  }, [location])

  // const page = window.location.pathname.split("/")[1];
  // const isHiddenMenusPage = [
  //   'privacy-policy', 'sign-up', 'app-setup', 'onboarding', 
  //   'onboarding-instaapp', 'onboarding-help', 'success', 'try-now'
  // ].includes(page);

  return (
    <header className="header">
      <nav className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <nav className="navbar navbar-expand-lg">
            <a className="navbar-brand" href="/">
              <img src="assets/images/logo.png" alt="logo" width="220" />
            </a>
            <button
              className="navbar-toggler collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon">
                <i className="fas fa-bars"></i>
              </span>
            </button>
            <div className="navbar-collapse collapse" id="navbarCollapse">
            {isDisplay && (
                <ul className="navbar-nav ml-auto">
                  <li className="current">
                    <a href="#home">Home</a>
                  </li>
                  <li>
                    <a href="#aboutus">About Us</a>
                  </li>
                  <li>
                    <a href="#pricing">Pricing</a>
                  </li>
                  <li>
                    <a href="#features">Features</a>
                  </li>
                  <li>
                    <a href="#faq">FAQ</a>
                  </li>
                  <li>
                    <a href="#contact">Contact</a>
                  </li>
                  {/* <li className="discover-link">
                    <a href="/admin" className="external discover-btn1" target="_blank" rel="noopener noreferrer">
                      Admin Login
                    </a>
                  </li> */}
                </ul>
              )}
            </div>
          </nav>
        </div>
      </nav>
    </header>
  );
};

export default Header;
